/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CurrentStatus } from './CurrentStatus';
import {
    CurrentStatusFromJSON,
    CurrentStatusFromJSONTyped,
    CurrentStatusToJSON,
    CurrentStatusToJSONTyped,
} from './CurrentStatus';

/**
 * 
 * @export
 * @interface LoginUser
 */
export interface LoginUser {
    /**
     * 
     * @type {number}
     * @memberof LoginUser
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof LoginUser
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof LoginUser
     */
    tenantId: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginUser
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof LoginUser
     */
    userMail: string;
    /**
     * 
     * @type {string}
     * @memberof LoginUser
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof LoginUser
     */
    authType: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginUser
     */
    businessCategory: string | null;
    /**
     * 
     * @type {Date}
     * @memberof LoginUser
     */
    systemDate: Date | null;
    /**
     * システムステータス
     * @type {Array<CurrentStatus>}
     * @memberof LoginUser
     */
    sysCurrentStatus: Array<CurrentStatus>;
}

/**
 * Check if a given object implements the LoginUser interface.
 */
export function instanceOfLoginUser(value: object): value is LoginUser {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('userMail' in value) || value['userMail'] === undefined) return false;
    if (!('userName' in value) || value['userName'] === undefined) return false;
    if (!('authType' in value) || value['authType'] === undefined) return false;
    if (!('businessCategory' in value) || value['businessCategory'] === undefined) return false;
    if (!('systemDate' in value) || value['systemDate'] === undefined) return false;
    if (!('sysCurrentStatus' in value) || value['sysCurrentStatus'] === undefined) return false;
    return true;
}

export function LoginUserFromJSON(json: any): LoginUser {
    return LoginUserFromJSONTyped(json, false);
}

export function LoginUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginUser {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'companyName': json['company_name'],
        'tenantId': json['tenant_id'],
        'userId': json['user_id'],
        'userMail': json['user_mail'],
        'userName': json['user_name'],
        'authType': json['auth_type'],
        'businessCategory': json['business_category'],
        'systemDate': (json['system_date'] == null ? null : new Date(json['system_date'])),
        'sysCurrentStatus': ((json['sys_current_status'] as Array<any>).map(CurrentStatusFromJSON)),
    };
}

export function LoginUserToJSON(json: any): LoginUser {
    return LoginUserToJSONTyped(json, false);
}

export function LoginUserToJSONTyped(value?: LoginUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'company_name': value['companyName'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
        'user_mail': value['userMail'],
        'user_name': value['userName'],
        'auth_type': value['authType'],
        'business_category': value['businessCategory'],
        'system_date': value['systemDate'] == null ? value['systemDate'] : value['systemDate'].toISOString().substring(0,10),
        'sys_current_status': ((value['sysCurrentStatus'] as Array<any>).map(CurrentStatusToJSON)),
    };
}

